import { z } from 'zod';
import { CnpjVO } from "../../../../common/validators/value-objects/cnpj.js";
import { PhoneVO } from "../../../../common/validators/value-objects/phone.js";
import { SlugVO } from "../../../../common/validators/value-objects/slug.js";
export const ContactInfoDTOSchema = z.object({
    phone: PhoneVO.nullable(),
    email: z.email().nullable(),
});
// Simplified: removed 'path' field (org_nodes removed)
export const BaseFacilityDTOSchema = z.object({
    id: z.string().uuid(),
    companyId: z.string().uuid(),
    name: z.string().min(2).max(32),
    legalName: z.string(),
    slug: SlugVO.SM,
    cnpj: CnpjVO.nullable(),
    address: z.any().nullable(), // Will be TExposedAddressDTO | null but avoiding circular imports
    contactInfo: ContactInfoDTOSchema.nullable(),
    bankAccount: z.any().nullable(), // Will be TExposedBankAccountDTO | null but avoiding circular imports
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    isDeleted: z.boolean(),
});
export const ExposedFacilityDTOSchema = BaseFacilityDTOSchema.omit({
    isDeleted: true,
    deletedAt: true,
});
//# sourceMappingURL=facilities.dto.js.map